/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { className, attributes } = props;
	const { layout } = attributes;
	const wrapperClasses = classnames(
		className,
		'flex-col-item',
		`gutenify-info-box-${ layout }`
	);

	return (
		<div className={ wrapperClasses }>
			<InnerBlocks.Content />
		</div>
	);
}
